var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom-bar"},[_c('div',{staticClass:"overlay"}),_c('img',{staticClass:"ribbon",attrs:{"src":require("@/assets/02_Filter-1.png")}})])
}]

export { render, staticRenderFns }